import React from 'react';
import { useTranslation } from 'react-i18next';
import layoutStyles from '../../styles/layout.module.css';
import styles from './OurProcess.module.css';

const OurProcess: React.FC = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: '🔍',
      step: 'step1',
      color: '#FF6B6B'
    },
    {
      icon: '📄',
      step: 'step2',
      color: '#FFD93D'
    },
    {
      icon: '⚙️',
      step: 'step3',
      color: '#6C5CE7'
    },
    {
      icon: '🚀',
      step: 'step4',
      color: '#95E1D3'
    },
    {
      icon: '🛟',
      step: 'step5',
      color: '#FF6B9D'
    }
  ];

  return (
    <div className={styles.colorWrapper}>
      <section id="OurProcess" className={`${layoutStyles.container} ${styles.ourProcess}`}>
        <h2>{t('ourProcess.title')}</h2>
        <div className={styles.stepsContainer}>
          {steps.map((step, index) => (
            <div key={index} className={styles.step}>
              <div 
                className={styles.iconCircle}
                style={{ backgroundColor: step.color }}
              >
                <span className={styles.icon}>{step.icon}</span>
              </div>
              <h3>{t(`ourProcess.steps.${step.step}.title`)}</h3>
              <p>{t(`ourProcess.steps.${step.step}.description`)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default OurProcess;

